import Api from "./baseApi";

const controllerPath = "/views";

const ViewsApi = {
  post(data) {
    return Api.post(`${controllerPath}`, data);
  },
  postView(view, data) {
    return Api.post(`${controllerPath}/${view}`, data);
  },
  upload(view, file, comment = '') {
    const formData = new FormData();
    formData.append("file", file);
    if (comment) {
      formData.append("comment", comment);
    }

    return Api.post(`${controllerPath}/${view}/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  getAll(options) {
    return Api.getList(`${controllerPath}`, options);
  },
  get(view) {
    return Api.get(`${controllerPath}/${view}`);
  },
  // Métodos específicos para PFS (usado pelo JsonEditor)
  list(options) {
    return Api.get("/views", options);
  },
  getPFS(view, options = {}) {
    const { raw, ...rest } = options || {};
    if (raw) {
      return Api.get(`/views/${view}?raw=true`, rest);
    }
    return Api.get(`/views/${view}`, rest);
  },
  uploadPFS(view, file, comment = '') {
    const formData = new FormData();
    formData.append("file", file);
    if (comment) {
      formData.append("comment", comment);
    }

    return Api.post(`/views/${view}/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};

export default ViewsApi;
